// Temporary global suspension requested on 9 October 2026.
// Does not remove saved diagnoses, historical associations or reporting data.
export const DHIS2_DOSSIER_ENABLED = false

export function sectionDisponibleDansDossier(section) {
    return DHIS2_DOSSIER_ENABLED || section.slug !== 'dhis2_diagnostics'
}
